var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QuestionBase',{attrs:{"question":_vm.question,"errors":[..._vm.jsErrors],"valid":_vm.data !== null}},[_c('InputRadio',{attrs:{"db":_vm.db,"options":_vm.booleanYesNo},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }